import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { CWY_COLORS } from '../../theme/colors';

export const NotificationSkeleton: React.FC = () => (
  <Box>
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.5,
          px: 2.5,
          py: 2,
          borderBottom: `1px solid ${CWY_COLORS.border}`,
        }}
      >
        <Skeleton variant="circular" width={48} height={48} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="85%" height={18} />
          <Skeleton variant="text" width="60%" height={16} sx={{ mt: 0.5 }} />
        </Box>
        <Skeleton variant="text" width={28} height={14} />
      </Box>
    ))}
  </Box>
);
